export default "__VITE_ASSET__DVv9GNkn__"